var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrigenBlanco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256,2C115.77,2,2,115.75,2,256.06S115.77,510,256,510,510.05,396.28,510.05,256.06,396.31,2,256,2ZM428.57,428.54A243.14,243.14,0,1,1,480.87,351,243.34,243.34,0,0,1,428.57,428.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M251,118.37V145h10V118.37a23.78,23.78,0,1,0-10,0Zm5-37a13.78,13.78,0,1,1-13.78,13.78A13.79,13.79,0,0,1,256,81.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M261,393.63V367H251v26.62a23.78,23.78,0,1,0,10,0Zm-5,37a13.78,13.78,0,1,1,13.78-13.78A13.79,13.79,0,0,1,256,430.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M416.87,232.22A23.81,23.81,0,0,0,393.63,251H367v10h26.62a23.78,23.78,0,1,0,23.24-28.78Zm0,37.56A13.78,13.78,0,1,1,430.65,256,13.79,13.79,0,0,1,416.87,269.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M349.79,155.14,331,174,338,181l18.83-18.83a23.8,23.8,0,0,0,29.71-3.15h0a23.78,23.78,0,1,0-36.78-3.92ZM360,132.51A13.78,13.78,0,1,1,360,152,13.72,13.72,0,0,1,360,132.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162.21,356.86,181,338,174,331l-18.83,18.83a23.81,23.81,0,0,0-29.71,3.15h0a23.78,23.78,0,1,0,36.78,3.92ZM152,379.49A13.77,13.77,0,0,1,132.51,360h0A13.78,13.78,0,0,1,152,379.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M356.86,349.79,338,331,331,338l18.83,18.83a23.81,23.81,0,0,0,3.15,29.71h0a23.78,23.78,0,1,0,3.92-36.78Zm22.64,29.7a13.79,13.79,0,0,1-19.49,0h0a13.77,13.77,0,1,1,19.49,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.25,166a23.72,23.72,0,0,0,12.89-3.8L174,181,181,174l-18.83-18.83a23.81,23.81,0,0,0-3.15-29.71h0A23.78,23.78,0,1,0,142.25,166Zm-9.75-33.5a13.78,13.78,0,1,1,0,19.48A13.74,13.74,0,0,1,132.5,132.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.61,197.94,104,196.11c-.6,1.52-1.19,3.09-1.75,4.64l4.7,1.69C107.46,200.94,108,199.42,108.61,197.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.36,207l-4.76-1.54c-.5,1.55-1,3.14-1.46,4.74l4.8,1.4C104.39,210,104.87,208.5,105.36,207Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.67,216.23,97.83,215c-.42,1.59-.81,3.21-1.17,4.83l4.87,1.1C101.89,219.34,102.27,217.77,102.67,216.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.54,225.61l-4.91-1c-.31,1.6-.6,3.25-.87,4.89l4.94.8C100,228.75,100.24,227.16,100.54,225.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120,165.39l4.15,2.78c.9-1.34,1.82-2.67,2.74-4l-4.07-2.9C121.91,162.64,121,164,120,165.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.58,172.21l-4.23-2.65c-.87,1.38-1.73,2.81-2.57,4.25l4.32,2.52C119.91,174.93,120.75,173.55,121.58,172.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.74,180.52l-4.4-2.39c-.78,1.45-1.56,2.93-2.3,4.4l4.47,2.25C115.22,183.36,116,181.93,116.74,180.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.41,189.11,107.88,187c-.69,1.48-1.38,3-2,4.53l4.59,2C111.08,192,111.74,190.54,112.41,189.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.47,302.19l-4.78,1.46c.48,1.56,1,3.12,1.48,4.61l4.74-1.59C105.42,305.21,104.93,303.71,104.47,302.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.47,311.09l-4.68,1.74c.55,1.51,1.14,3,1.75,4.52l4.63-1.88C108.59,314,108,312.55,107.47,311.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111,319.79l-4.58,2c.65,1.46,1.33,2.94,2,4.4l4.52-2.15C112.28,322.65,111.63,321.21,111,319.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115,328.26l-4.45,2.29c.75,1.45,1.52,2.89,2.28,4.27l4.38-2.41C116.51,331.07,115.76,329.67,115,328.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.21,351.19l4.06-2.91c-.9-1.26-1.8-2.56-2.68-3.86l-4.14,2.8C121.35,348.56,122.28,349.89,123.21,351.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.58,336.48,115.27,339c.83,1.39,1.68,2.78,2.53,4.13l4.23-2.67Q120.79,338.53,119.58,336.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.09,284l-4.93.88c.29,1.59.6,3.19.92,4.75l4.9-1C100.66,287.05,100.36,285.5,100.09,284Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102,293.14l-4.87,1.17c.38,1.56.79,3.14,1.21,4.69l4.82-1.32C102.76,296.19,102.37,294.66,102,293.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.37,261H145V251H118.37a23.78,23.78,0,1,0-24,28.76l0,.26,1.86-.27A23.81,23.81,0,0,0,118.37,261Zm-37-5a13.78,13.78,0,1,1,13.78,13.78A13.79,13.79,0,0,1,81.35,256Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.08,411.28c1.55.5,3.12,1,4.66,1.45l1.42-4.8c-1.5-.44-3-.91-4.53-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.45,414c1.57.41,3.16.8,4.75,1.17l1.12-4.87c-1.53-.36-3.08-.74-4.6-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M186.91,404.08c1.47.69,3,1.37,4.46,2l2-4.59c-1.44-.62-2.89-1.28-4.32-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.88,408c1.51.59,3.05,1.18,4.58,1.73l1.7-4.71c-1.48-.53-3-1.09-4.44-1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224,416.23c1.59.32,3.2.62,4.8.88l.83-4.93c-1.55-.26-3.12-.54-4.66-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.6,389.36c1.33.94,2.69,1.87,4,2.76L168.4,388c-1.3-.87-2.62-1.77-3.9-2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M169.74,394.77c1.38.86,2.79,1.71,4.19,2.52l2.51-4.32c-1.35-.79-2.72-1.61-4.06-2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.19,399.69c1.43.77,2.89,1.54,4.33,2.26l2.25-4.46c-1.39-.71-2.81-1.44-4.2-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M327.27,397.47l2.25,4.46c1.48-.74,3-1.52,4.4-2.3l-2.39-4.4C330.13,396,328.7,396.75,327.27,397.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M343.88,387.77l2.78,4.16c1.37-.92,2.74-1.86,4.09-2.82L347.84,385C346.54,386,345.21,386.88,343.88,387.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.13,410.46l1.1,4.88c1.61-.37,3.24-.76,4.83-1.17l-1.25-4.84C294.26,409.73,292.69,410.11,291.13,410.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.55,401.54l2,4.59c1.52-.65,3-1.34,4.53-2l-2.12-4.53C321.5,400.24,320,400.91,318.55,401.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.68,412.3l.81,4.93c1.63-.26,3.27-.56,4.89-.87l-1-4.91C284.86,411.76,283.27,412,281.68,412.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.45,408.05l1.4,4.8c1.58-.46,3.18-1,4.74-1.46L305,406.63C303.53,407.13,302,407.6,300.45,408.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M335.72,392.87l2.52,4.32c1.42-.83,2.85-1.69,4.25-2.57l-2.65-4.24C338.48,391.23,337.1,392.07,335.72,392.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.6,405.07l1.69,4.71c1.55-.56,3.12-1.15,4.64-1.75l-1.83-4.65C312.62,404,311.1,404.53,309.6,405.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M409,297.23l4.83,1.3c.42-1.55.81-3.12,1.18-4.67l-4.86-1.16C409.74,294.2,409.36,295.73,409,297.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M411.11,288.14l4.89,1c.33-1.57.63-3.17.91-4.74l-4.93-.86C411.72,285.07,411.42,286.61,411.11,288.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M403,315l4.63,1.87c.6-1.47,1.18-3,1.73-4.5l-4.69-1.73C404.17,312.06,403.61,313.53,403,315Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M399.3,323.52l4.52,2.14c.68-1.44,1.35-2.92,2-4.39l-4.58-2C400.61,320.69,400,322.13,399.3,323.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M392,346.62l-4.16-2.78c-.87,1.29-1.76,2.59-2.66,3.85l4.08,2.9C390.14,349.29,391.06,348,392,346.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M395.06,331.85l4.39,2.4c.76-1.39,1.51-2.83,2.25-4.26l-4.46-2.27C396.53,329.11,395.8,330.5,395.06,331.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M406.26,306.18l4.74,1.59c.5-1.51,1-3,1.46-4.6l-4.79-1.44C407.22,303.23,406.74,304.73,406.26,306.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M390.33,339.92l4.24,2.65c.85-1.36,1.69-2.74,2.5-4.12l-4.31-2.53C392,337.26,391.16,338.6,390.33,339.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M412.3,230.33l4.94-.81c-.27-1.63-.56-3.27-.88-4.87l-4.9.95C411.76,227.16,412,228.75,412.3,230.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M385.13,164.29c.92,1.29,1.84,2.62,2.73,4l4.15-2.78c-.91-1.37-1.86-2.75-2.81-4.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M410.47,220.9l4.88-1.11c-.37-1.61-.76-3.23-1.17-4.81l-4.84,1.25C409.73,217.76,410.11,219.33,410.47,220.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M401.58,193.54l4.59-2c-.65-1.52-1.33-3-2-4.52l-4.53,2.11C400.29,190.59,401,192.07,401.58,193.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M397.52,184.83l4.47-2.25c-.75-1.47-1.52-3-2.3-4.39l-4.4,2.39C396.05,182,396.8,183.41,397.52,184.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M408.06,211.6l4.8-1.4c-.46-1.59-.95-3.18-1.45-4.73L406.65,207C407.14,208.51,407.61,210.06,408.06,211.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M405.1,202.47l4.7-1.69c-.55-1.54-1.14-3.1-1.74-4.63L403.41,198C404,199.46,404.56,201,405.1,202.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M392.94,176.39l4.32-2.52c-.84-1.43-1.7-2.85-2.56-4.24l-4.24,2.65C391.3,173.62,392.13,175,392.94,176.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M334.59,112.74c-1.43-.79-2.9-1.57-4.37-2.32L328,114.88c1.42.72,2.84,1.48,4.23,2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M343.1,117.76c-1.38-.87-2.8-1.74-4.22-2.57l-2.54,4.3c1.38.81,2.75,1.65,4.09,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325.79,108.24c-1.49-.7-3-1.39-4.5-2l-2,4.58c1.45.63,2.92,1.3,4.36,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M351.29,123.29c-1.33-1-2.7-1.91-4.05-2.83l-2.8,4.15c1.32.88,2.64,1.81,3.94,2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298,98.07c-1.59-.42-3.2-.82-4.79-1.19L292,101.75c1.54.36,3.11.75,4.65,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M316.73,104.29c-1.54-.61-3.09-1.21-4.62-1.77l-1.71,4.7c1.48.54,3,1.12,4.47,1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.35,95.83c-1.61-.32-3.25-.62-4.86-.9l-.84,4.93c1.57.27,3.15.56,4.71.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.45,100.89c-1.55-.51-3.14-1-4.72-1.48l-1.43,4.79c1.53.46,3.07.94,4.57,1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.17,119.19l-2.52-4.32c-1.43.84-2.86,1.71-4.26,2.58l2.66,4.24C173.4,120.84,174.79,120,176.17,119.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.63,114.58l-2.25-4.46c-1.47.74-2.95,1.52-4.4,2.31l2.39,4.39C181.77,116.05,183.21,115.3,184.63,114.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168,124.31l-2.78-4.16c-1.36.91-2.73,1.86-4.09,2.83l2.91,4.07C165.35,126.11,166.68,125.19,168,124.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193.36,110.5l-2-4.59c-1.51.64-3,1.33-4.54,2l2.12,4.53C190.43,111.79,191.91,111.13,193.36,110.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M220.82,101.55l-1.11-4.88c-1.61.37-3.24.77-4.83,1.18l1.26,4.84C217.68,102.29,219.25,101.9,220.82,101.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.33,107l-1.7-4.71c-1.54.56-3.1,1.15-4.65,1.76l1.84,4.65C199.32,108.07,200.83,107.49,202.33,107Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.28,99.71l-.81-4.94c-1.63.27-3.28.56-4.89.88l.95,4.91C227.1,100.25,228.7,100,230.28,99.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.49,104l-1.4-4.8c-1.59.46-3.19,1-4.75,1.47l1.55,4.75C208.41,104.9,210,104.42,211.49,104Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M252.6,348.06a5,5,0,0,0,8.06,0c.51-.68,50.13-68.37,51.85-70.7a70.5,70.5,0,0,0,15.37-44.22,71.25,71.25,0,0,0-142.5,0,70.45,70.45,0,0,0,15.37,44.21Zm4-176.17a61.32,61.32,0,0,1,61.25,61.25,60.61,60.61,0,0,1-13.25,38.06l0,0c-.62.74-1.37,1.76-2.39,3.16l-45.65,62.25-47.87-65.29-.12-.16a60.58,60.58,0,0,1-13.26-38.06A61.32,61.32,0,0,1,256.63,171.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.24,271.85a36.1,36.1,0,1,0-36.1-36.1A36.1,36.1,0,0,0,258.24,271.85Zm0-62.2a26.1,26.1,0,1,1-26.1,26.1A26.13,26.13,0,0,1,258.24,209.65Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrigenBlanco);
export default __webpack_public_path__ + "static/media/origen_blanco.4044956c467c21e7a8be37967f1818cc.svg";
export { ForwardRef as ReactComponent };